const toastMessages = {
  'toast.message.tag.import': 'タグをインポートしました。',
  'toast.message.tag.update': 'タグを更新しました。',
  'toast.message.tag.delete': 'タグを削除しました。',
  'toast.message.tag.restore': '削除したタグを元に戻しました。',
  'toast.message.company.setting.accessControl':
    'アクセス制御の設定を更新しました。',
  'toast.message.report.autoSave': '自動保存が完了しました。',
};

export default toastMessages;
